import { createContext, useContext, type ReactNode } from 'react';
import type { ApiServices } from './lib/services';

const ApiContext = createContext<ApiServices | undefined>(undefined);

export function ApiProvider({
  children,
  services,
}: {
  children: ReactNode;
  services: ApiServices;
}) {
  return <ApiContext.Provider value={services}>{children}</ApiContext.Provider>;
}

export function useApi(): ApiServices {
  const context = useContext(ApiContext);
  if (!context) {
    throw new Error('useApi must be used within ApiProvider');
  }
  return context;
}
